import { create } from 'apisauce';
import { Auth } from '../Redux/reducers/auth';
import { store } from '../Redux/store';
import { apiKey, getServer } from '../Utils/url';
import { Error } from '../Redux/reducers/error';

export const GET = 'GET';
export const FIND = 'FIND';
export const FIND_KEY = 'FIND_KEY';
export const GET_KEY = 'GET_KEY';
export const SAVE_KEY = 'SAVE_KEY';
export const UPDATE_KEY = 'UPDATE_KEY';
export const SAVE = 'POST';
export const UPDATE = 'PATCH';
export const FILE_SAVE = 'FILE_SAVE';
export const FILE_UPDATE = 'FILE_UPDATE';
export const DELETE = 'DELETE';
export const STAMP_INVOICE = 'STAMP_INVOICE';
export const SEND_INVOICE = 'SEND_INVOICE';
export const CANCEL_INVOICE = 'CANCEL_INVOICE';

export const token = () => store.getState().auth.token;
// Define the api
const API = create({
  baseURL: getServer(),
});
const monitor = response => {
  if (response.status === 401) {
    store.dispatch(Auth.authClear());
  }
  if (!response.ok) {
    if (response.status !== 401) {
      let aExclusions = ['/users'];
      if (aExclusions.indexOf(response.config.url) !== -1) {
        store.dispatch(Error.errorSet(response));
      }
    }
  }
};

API.addMonitor(monitor);

export async function login(email, password) {
  return await API.post('/auth', { email, password, strategy: 'local' });
}

export async function verify(sToken) {
  return await API.get(
    `/verify/${sToken}`,
    {},
    {
      headers: {
        'x-api-key': 'FTQrGvZPbhwI/n1poyJEgDETP4DcBi/SomxN7jQpOR0=',
      },
    }
  );
}

/**
 * Generic function to make api calls
 * @param {ENUM} operation - Consts FIND, GET, SAVE or UPDATE
 * @param {string} model - Model name in API
 * @param {object} payload - Data to send
 * @param {object} params - Object that can contain id of model or queries and skip for find calls.
 */
export async function process(operation, model, payload = {}, params = {}) {
  const { id, queries, limit, skip } = params || {};
  const oAuth = {
    headers: {
      Authorization: `BEARER ${token()}`,
    },
  };
  const key = apiKey();

  switch (operation) {
    case FIND:
      return await API.get(
        `/${model}?${queries ? queries + '&' : ''}${
          limit ? '$limit=' + limit : ''
        }&$skip=${skip}`,
        null,
        oAuth
      );
    case GET:
      return await API.get(`/${model}/${id}${queries || ''}`, null, oAuth);
    case SAVE:
      return await API.post(`/${model}`, payload, oAuth);
    case UPDATE:
      return await API.patch(`/${model}/${id}`, payload, oAuth);
    case DELETE:
      return await API.delete(`/${model}/${id}`, null, oAuth);
    case FILE_SAVE:
      return await API.post(`/${model}`, payload, {
        headers: {
          Authorization: `BEARER ${token()}`,
          'Content-Type': 'multipart/form-data',
        },
      });
    case FILE_UPDATE:
      return await API.patch(`/${model}/${id}`, payload, {
        headers: {
          Authorization: `BEARER ${token()}`,
          'Content-Type': 'multipart/form-data',
        },
      });

    case SAVE_KEY:
      return await API.post(`/${model}`, payload, {
        headers: {
          'x-api-key': key,
        },
      });

    case UPDATE_KEY:
      return await API.patch(`/${model}/${id}`, payload, {
        headers: {
          'x-api-key': key,
        },
      });

    case FIND_KEY:
      return await API.get(
        `/${model}?${queries ? queries + '&' : ''}${
          limit ? '$limit=' + limit : ''
        }&$skip=${skip}`,
        null,
        {
          headers: {
            'x-api-key': key,
          },
        }
      );

    case GET_KEY:
      return await API.get(`/${model}/${id}${queries || ''}`, null, {
        headers: {
          'x-api-key': key,
        },
      });
    case STAMP_INVOICE:
      return await API.post(`/${model}/stamp`, payload, oAuth);
    case CANCEL_INVOICE:
      return await API.post(`/${model}/cancel`, payload, oAuth);
    case SEND_INVOICE:
      return await API.post(`/${model}/send`, payload, oAuth);
    default:
      return null;
  }
}
